export class FileDocument {
  constructor(data) {
    Object.assign(this, data);
  }
}
export class DocumentReviewReferenceDocument {
  constructor(data) {
    this.documents = (data.documents || []).map((doc) => new FileDocument(doc));
    this.photos = (data.photos || []).map((photo) => new FileDocument(photo));
  }
}
